import Axios from '../axios-instance';

const EmailNotificationAPI = {
  get: body => {
    return Axios.post(`/EmailsNotifications/Get`, body).then(({ data }) => data);
  },

  newEmailNotification: body => {
    
    return Axios.post('EmailsNotifications/Insert', body ).then(({ data }) => data);
  },

  getEmail: body => {
    return Axios.post(`/EmailsNotifications/GetEmail`, body).then(({ data }) => data);
  },

  modify: body => {
    return Axios.put(`/EmailsNotifications/ChangeEmail`, body).then(({ data }) => data);
  },

  delete: body => {
    return Axios.post(`/EmailsNotifications/Delete`, body).then(({ data }) => data);
  }
};


export default EmailNotificationAPI;